import React from 'react';
import { ActionBadge } from './action-badge';

export interface IDocumentIdBadgeProps {
    accountId?: string;
    className?: string;
    hideAction?: boolean;
    id: string;
    onCopy?: (url: string) => void;
    onRemove?: () => void;
    removeLabel?: string;
    openInNewTab?: boolean;
}
export const DocumentIdBadge: React.FunctionComponent<IDocumentIdBadgeProps> = (
    props: IDocumentIdBadgeProps,
): React.ReactElement => {
    const { accountId, className, hideAction, id, onCopy, onRemove, removeLabel, openInNewTab } = props;
    const path = accountId ? `/${accountId}/documents/${id}` : `/documents/${id}`;
    return (
        <ActionBadge
            className={className}
            hideAction={hideAction}
            path={path}
            tooltip="View Document"
            onCopy={onCopy}
            onRemove={onRemove}
            openInNewTab={openInNewTab}
            removeLabel={removeLabel}>
            Document ID – {id}
        </ActionBadge>
    );
};
